import {
  pgTable, uuid, text, timestamp, integer, boolean, jsonb, index,
} from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

// ---------------------------------------------------------------------------
// NPS/CSAT Survey System (S.3)
// ---------------------------------------------------------------------------

export const SURVEY_TYPES = ["nps", "csat", "ces", "custom"] as const;
export type SurveyType = (typeof SURVEY_TYPES)[number];

export const surveyConfigs = pgTable("survey_configs", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  name: text("name").notNull(),
  surveyType: text("survey_type").notNull(), // SurveyType
  triggerEvent: text("trigger_event").notNull(), // event type that triggers survey
  delayMinutes: integer("delay_minutes").notNull().default(1440), // 24h default
  questions: jsonb("questions").$type<Array<{ question: string; type: string }>>(),
  isActive: boolean("is_active").notNull().default(true),
  createdAt: timestamp("created_at", tz).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
}, (table) => [
  index("idx_survey_configs_tenant").on(table.tenantId),
  index("idx_survey_configs_trigger").on(table.tenantId, table.triggerEvent),
]);

export const surveyResponses = pgTable("survey_responses", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  configId: uuid("config_id").notNull(),
  personId: uuid("person_id").notNull(),
  bookingId: uuid("booking_id"),
  jobId: uuid("job_id"),
  score: integer("score").notNull(), // 0-10 NPS, 1-5 CSAT
  comment: text("comment"),
  respondedAt: timestamp("responded_at", tz).notNull().defaultNow(),
  createdAt: timestamp("created_at", tz).notNull().defaultNow(),
}, (table) => [
  index("idx_survey_responses_tenant").on(table.tenantId),
  index("idx_survey_responses_person").on(table.tenantId, table.personId),
  index("idx_survey_responses_config").on(table.configId),
  index("idx_survey_responses_responded").on(table.tenantId, table.respondedAt),
]);
